import React from 'react';

import { CardPaymentDetailsSummary } from 'containers/CardPaymentDetails';
import { ModalLayerComponent } from 'design/modalLayer';
import { SidebarModalWindowComponent } from 'design/sidebarModal';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { useAppDispatcher } from 'hooks/useAppDispatcher';

type Props = {
  cardPaymentId: number;
  onShowClientDetails(clientId: number): void;
};

export const CardPaymentDetails = (props: Props) => {
  const { cardPaymentId, onShowClientDetails } = props;

  const dispatch = useAppDispatcher();

  const close = React.useCallback(() => {
    dispatch({
      name: 'CardPaymentManager__Closed',
    });
  }, [dispatch]);

  return (
    <ModalLayerComponent theme="transparent">
      <SidebarModalWindowComponent
        onMisclick={close}
        onEscape={close}
        onClose={close}
      >
        <AsyncBoundaryComponent fallback={null}>
          <CardPaymentDetailsSummary
            cardPaymentId={cardPaymentId}
            onShowClientDetails={onShowClientDetails}
          />
        </AsyncBoundaryComponent>
      </SidebarModalWindowComponent>
    </ModalLayerComponent>
  );
};
